/* eslint-disable react/no-unescaped-entities */
import * as S from './AnswerListeningDictation.styles';
import { Waveform } from '@app/components/exam/Waveform';
import { ScoreInfo } from '@app/components/exam/ScoreInfo';
import { useState } from 'react';
import { WordItem } from '@app/interfaces/interfaces';

interface ListeningDictationProps {
  audioURL: string;
  gradingContent: string;
  answer: string;
  questionId: string;
}
export const AnswerListeningDictation: React.FC<ListeningDictationProps> = ({
  audioURL,
  gradingContent,
  answer,
  questionId,
}) => {
  const [words, setWords] = useState<WordItem[]>([]);

  const compareSentences = (correct: string[], user: string[]) => {
    const result = [];
    const correctMap = new Map();
    const userMap = new Map();

    // Đếm số lần xuất hiện của từng từ
    correct.forEach((word) => correctMap.set(word, (correctMap.get(word) || 0) + 1));
    user.forEach((word) => userMap.set(word, (userMap.get(word) || 0) + 1));

    let correctIndex = 0,
      userIndex = 0;

    while (correctIndex < correct.length || userIndex < user.length) {
      const correctWord = correct[correctIndex] || '';
      const userWord = user[userIndex] || '';

      if (correctWord === userWord) {
        result.push(
          <span key={`correct-${userIndex}`} className="text-green-500">
            {userWord}{' '}
          </span>,
        );
        correctMap.set(correctWord, correctMap.get(correctWord)! - 1);
        userMap.set(userWord, userMap.get(userWord)! - 1);
        correctIndex++;
        userIndex++;
      } else if (userWord && (!correctMap.has(userWord) || correctMap.get(userWord) === 0)) {
        // Nếu từ bị thừa
        result.push(
          <span key={`extra-${userIndex}`} className="text-black">
            {userWord}{' '}
          </span>,
        );
        userIndex++;
      } else if (correctWord && (!userMap.has(correctWord) || userMap.get(correctWord) === 0)) {
        // Nếu từ bị thiếu
        result.push(
          <span key={`missing-${correctIndex}`} className="text-red-500">
            {correctWord}{' '}
          </span>,
        );
        correctIndex++;
      } else {
        correctIndex++;
        userIndex++;
      }
    }

    return result;
  };

  return (
    <S.CardAnswer>
      <S.CardAnswerHead>
        <S.Title level={5}>Answer</S.Title>
      </S.CardAnswerHead>

      <S.Audio>
        <p className="text-sm font-semibold mb-4">System's Answer</p>
        {/* {audioURL && <Waveform url={audioURL} />} */}
        <p className="text-sm font-semibold mt-4">{gradingContent}</p>

        <S.LevelList>
          <div className="flex items-center gap-2">
            <S.Good></S.Good>
            <span className="text-black">Good</span>
          </div>
          <div className="flex items-center gap-2">
            <S.Average></S.Average>
            <span className="text-black">Average</span>
          </div>
          <div className="flex items-center gap-2">
            <S.Missing></S.Missing>
            <span className="text-black">Missing</span>
          </div>
        </S.LevelList>
      </S.Audio>

      <S.CardAnswerBody>
        <S.Grading>Transcript</S.Grading>
        <S.Content>
          <S.TextRed>{gradingContent}</S.TextRed>
        </S.Content>
        <S.Grading>Grading</S.Grading>
        <S.Content>{compareSentences(gradingContent.split(' '), answer.split(' '))}</S.Content>
      </S.CardAnswerBody>
      <S.CardAnswerFooter>
        <ScoreInfo answer={answer} questionId={questionId} setWords={setWords} />
      </S.CardAnswerFooter>
    </S.CardAnswer>
  );
};
